export function stripCodeFences(text: string): string {
  let result = text;
  // Remove leading code fence like ```json or ```
  result = result.replace(/^\s*```[a-zA-Z]*\s*\r?\n/, "");
  // Remove trailing closing fence
  result = result.replace(/\r?\n?\s*```\s*$/, "");
  return result;
}


